import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// confirmation-dialog.component.ts

export interface ConfirmationDialogData {
  title?: string;
  message: string;
  trueText?: string;
  falseText?: string;
  icon?: string;
  dangerMode?: boolean;

  // ── New properties for reason input ───────────────────────────────
  showReasonInput?: boolean;       
  reasonLabel?: string;            
  reasonPlaceholder?: string;       
  reasonRequired: boolean ;        
  reasonInitialValue?: string;
  reasonMaxLength?: number;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent {

  reason: string = '';
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    // Default values if not provided
    this.data.trueText  = this.data.trueText  ?? 'Confirm';
    this.data.falseText = this.data.falseText ?? 'Cancel';
    this.data.icon      = this.data.icon      ?? 'ri-information-line';
    this.data.showReasonInput = this.data.showReasonInput ?? this.data.dangerMode ?? false;
    this.reason = this.data.reasonInitialValue ?? '';
  }
onConfirm(result: boolean): void {
    if (result) {
      // User clicked confirm → send reason if input was shown
      this.dialogRef.close({
        confirmed: true,
        reason: this.data.showReasonInput ? (this.reason?.trim() || undefined) : undefined
      });
    } else {
      // Cancel / No
      this.dialogRef.close({ confirmed: false });
    }
  }
}